import { SxProps } from '@mui/material'
import { scaledPx } from '@/styles'
import { iconSlot, railTransitionMs } from '../SidebarLayout.data'

interface SidebarProfileStyles {
  row: SxProps
  rowRail: SxProps
  rowRound: SxProps
  avatarSlot: SxProps
  avatarSlotRail: SxProps
  avatar: SxProps
  avatarImage: SxProps
  avatarIcon: SxProps
  avatarIconGlyph: SxProps
  details: SxProps
  name: SxProps
  email: SxProps
  chevronIcon: SxProps
}

const avatarBase: SxProps = {
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: scaledPx(34),
  height: scaledPx(34),
  borderRadius: '50%',
}

export const sidebarProfileStyles: SidebarProfileStyles = {
  // The mobile drawer's version, and the original.
  row: {
    display: 'flex',
    alignItems: 'center',
    // Explicit, because ButtonBase centres its content by default: while the rail
    // opens this row holds only the avatar, which would otherwise track the centre
    // of the growing row and snap back once the name appeared beside it.
    justifyContent: 'flex-start',
    gap: 1.25,
    width: '100%',
    minHeight: scaledPx(52),
    px: 1,
    py: 1,
    borderRadius: 2,
    textAlign: 'left',
    color: 'text.primary900',
    transition: 'background .2s',
    '&:hover': {
      backgroundColor: 'utils.gray50',
    },
  },
  // The desktop rail's version: padding that never changes, so the avatar holds
  // its place while the row grows around it.
  rowRail: {
    gap: 0,
    minHeight: scaledPx(iconSlot),
    px: 0,
    py: 0,
    transition: `border-radius ${railTransitionMs}ms ease, background .2s`,
  },
  // Collapsed, only the corners change, so the hover halo is a circle round the
  // avatar rather than a rounded rectangle.
  rowRound: {
    borderRadius: 999,
  },
  avatarSlot: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarSlotRail: {
    width: scaledPx(iconSlot),
    minHeight: scaledPx(iconSlot),
  },
  avatar: {
    ...(avatarBase as object),
    overflow: 'hidden',
    backgroundColor: 'utils.gray950',
    color: 'background.default',
    typography: 'textSmSemibold',
  },
  avatarImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  avatarIcon: {
    ...(avatarBase as object),
    backgroundColor: 'utils.gray200',
    color: 'text.tertiary600',
  },
  avatarIconGlyph: {
    width: scaledPx(18),
    height: scaledPx(18),
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flex: 1,
    minWidth: 0,
  },
  name: {
    typography: 'textSmSemibold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  // Body size rather than textXs — at this UI density textXs reads as squashed.
  email: {
    typography: 'textSm',
    color: 'text.tertiary600',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  chevronIcon: {
    flexShrink: 0,
    width: scaledPx(16),
    height: scaledPx(16),
    color: 'text.tertiary600',
  },
}
